export default __webpack_public_path__ + "static/media/watch.43c8f236.svg";